module.exports = __webpack_public_path__ + "media/sk_logo_black.8dd3212f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sk_logo_black.png
// module id = 1361
// module chunks = 57